import { useEffect, useState } from 'react'
import { BACKEND_URL_PREFIX } from '../../../utils/const'

/*
  Пять публичных списков. Методы те же, что были: отдельного запроса на счётчик нет —
  количество берётся из этого же ответа.

  TODO: пока методы отдают разный формат (массив / { items }, разные имена полей),
  поле наименования задаётся здесь явно. После унификации ответов на бэке
  останутся общие name/id и разбор ниже уйдёт.
*/
export const GUEST_LISTS = {
  'Направления подготовки': { url: 'all_train_dirs', nameKey: 'training_direct', idKey: 'training_direct_id' },
  'Образовательные стандарты': { url: 'all_edu_stands', nameKey: 'program_name', idKey: 'edu_direct_id' },
  'Факультеты': { url: 'faculty', nameKey: 'faculty', idKey: 'idfaculty' },
  'Кафедры': { url: 'cathedra', nameKey: 'cathedra', idKey: 'idcathedra' },
  'Структурные подразделения': {
    url: 'divisions_list',
    nameKey: 'divisionname',
    idKey: 'sdid',
    parentKey: 'parentname',
  },
}

const TITLES = Object.keys(GUEST_LISTS)

const initialState = () =>
  TITLES.reduce((acc, title) => ({ ...acc, [title]: { loading: true, error: false, items: null } }), {})

export const useGuestLists = () => {
  const [lists, setLists] = useState(initialState)

  useEffect(() => {
    let cancelled = false

    const load = async title => {
      const { url, nameKey, idKey, parentKey } = GUEST_LISTS[title]
      try {
        const response = await fetch(`${BACKEND_URL_PREFIX}/${url}`)
        if (!response.ok) throw new Error(response.status)
        const data = await response.json()
        const rows = Array.isArray(data) ? data : data?.items || []
        // порядок задаёт сервер — на клиенте не пересортировываем
        const items = rows.map((row, index) => ({
          id: row[idKey] ?? index,
          name: row.name ?? row[nameKey] ?? '',
          parent: parentKey ? row[parentKey] : null,
        }))
        if (!cancelled) setLists(prev => ({ ...prev, [title]: { loading: false, error: false, items } }))
      } catch (err) {
        if (!cancelled) setLists(prev => ({ ...prev, [title]: { loading: false, error: true, items: null } }))
      }
    }

    TITLES.forEach(load)
    return () => {
      cancelled = true
    }
  }, [])

  return lists
}
